<template>
  <HeadlessDialog :open class="relative z-50" @close="close">
    <div class="fixed inset-0 bg-black/30" aria-hidden="true"></div>

    <div class="fixed inset-0 w-screen flex items-center max-h-screen">
      <div
        class="h-full w-full"
        :class="{ 'max-h-[80%] w-[80%] max-w-2xl mx-auto': !isFullScreen }"
      >
        <HeadlessDialogPanel
          class="w-full h-full flex flex-col bg-bgr"
          :class="{ 'rounded-lg': !isFullScreen }"
        >
          <header
            v-if="$slots.header || $slots.title"
            class="sticky top-0 flex items-center justify-between border-b p-3 max-md:bg-bgr-100 sm:min-h-[4.5rem]"
          >
            <slot name="header">
              <HeadlessDialogTitle as="template" class="text-xl font-medium">
                <slot name="title"></slot>
              </HeadlessDialogTitle>

              <button
                class="absolute right-4 rounded-full p-1 transition focus:bg-bgr-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-thm-hover focus:border-thm-hover"
                @click="close"
              >
                <WebccIcon name="site/x" class="h-6 w-6 text-txt-weak" />
              </button>
            </slot>
          </header>

          <section class="flex-1 overflow-y-auto">
            <slot></slot>
          </section>

          <footer
            v-if="$slots.footer"
            class="sticky bottom-0 flex w-full flex-row flex-wrap justify-between border-t p-3 max-md:bg-bgr-100"
          >
            <slot name="footer"> </slot>
          </footer>
        </HeadlessDialogPanel>
      </div>
    </div>
  </HeadlessDialog>
</template>

<script setup lang="ts">
import { isString } from 'lodash-es'

const props = defineProps<{
  open?: boolean
  fullScreen?: boolean | ScreenSize
}>()

const emit = defineEmits<{ close: [] }>()

const screen = useScreen()

const isFullScreen = computed(() => {
  return isString(props.fullScreen)
    ? screen.breakpoints.smaller(props.fullScreen).value
    : !!props.fullScreen
})

function close() {
  emit('close')
}
</script>
